/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function CodeIcon({
  className = '',
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.07031 7.41563L4.46953 12.0152L9.05391 16.5996L8.00039 17.6543L2.34726 12L8.00039 6.34571L9.07031 7.41563ZM21.6539 12L16.0008 17.6543L14.9309 16.5844L19.5317 11.9848L14.9473 7.40039L16.0008 6.34571L21.6539 12Z"
        fill="#1E2732"
        fillOpacity="0.8"
      />
    </svg>
  )
}

CodeIcon.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default CodeIcon
